module.exports = __webpack_public_path__ + "img/image48.0aab1e7e.png";